import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  References31yy1vpluik8j as References,
  Description1f0zycfwk0zld as Description,
  AdminTitleFields1r7jr8w0z0gjc as AdminTitleFields,
  AdminTableColumns127mx0x3shj3w as AdminTableColumns,
  NaturalSort21fbc8xpuy7g0 as NaturalSort,
} from '../../../../service-abstractions-data-shared/com/lightningkite/services/data/Annotations.mjs';
import { UuidSerializer_getInstance1ib26ji9vwcd4 as UuidSerializer_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Companion_getInstance3o354p9o0zadk as Companion_getInstance,
  ExcelLikeFormula3nl4zwq7og62 as ExcelLikeFormula,
  ExcelLikeFormula__toString_impl_rnbgi1zeuj2qebb9le as ExcelLikeFormula__toString_impl_rnbgi1,
  ExcelLikeFormula__hashCode_impl_5w5jp6fcwlwnsu3lo4 as ExcelLikeFormula__hashCode_impl_5w5jp6,
} from './excel.mjs';
import {
  $serializer_getInstance2d6r634jjn3di as $serializer_getInstance,
  $serializer_getInstance2mjsn9cwe2nf as $serializer_getInstance_0,
  $serializer_getInstance26w9jyto543s8 as $serializer_getInstance_1,
} from './excelInputs.mjs';
import {
  DoubleSerializer_getInstance1tuvibnyg07o1 as DoubleSerializer_getInstance,
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  compareTo1g8l26b65emtd as compareTo,
  TypedIdexo9ecsepo30 as TypedId,
  HasId24qpfucecockd as HasId,
} from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasId.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  $serializer_getInstance2m8ynx42p4oox as $serializer_getInstance_2,
  IDqqik72jjbpsn as ID,
  ID__toString_impl_y5caka2oopvpysxo85x as ID__toString_impl_y5caka,
  ID__hashCode_impl_f4lulzrhf9x0v3ec95 as ID__hashCode_impl_f4lulz,
  $serializer_getInstance2jfn7wtddihen as $serializer_getInstance_3,
  ID1lyj7m2ox8cp5 as ID_0,
  ID__toString_impl_y5cakawnw120meic4d as ID__toString_impl_y5caka_0,
  ID__hashCode_impl_f4lulzwl94qweqdore as ID__hashCode_impl_f4lulz_0,
} from './domain.mjs';
import { $serializer_getInstancegx2p6odi22tj as $serializer_getInstance_4 } from './types.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _ID___init__impl__k1lb7e(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5($this) {
  return $this;
}
function ID__toString_impl_y5caka_1($this) {
  return _ID___get_raw__impl__92g6u5($this).toString();
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_5();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.EmployerRate.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(EmployerRate())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_ahi7en_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ahi7en_k$(encoder, value instanceof ID_1() ? value.raw_1 : THROW_CCE());
      }
      deserialize_bgog8e_k$(decoder) {
        return _ID___init__impl__k1lb7e(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_1())(this.deserialize_bgog8e_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_5() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function ID__hashCode_impl_f4lulz_1($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p($this, other) {
  if (!(other instanceof ID_1()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_1())(other instanceof ID_1() ? other.raw_1 : THROW_CCE()));
}
function EmployerRate$Companion$$childSerializers$_anonymous__42rifl() {
  return Companion_getInstance().serializer_vc198b_k$($serializer_getInstance(), DoubleSerializer_getInstance());
}
function EmployerRate$Companion$$childSerializers$_anonymous__42rifl_0() {
  return Companion_getInstance().serializer_vc198b_k$($serializer_getInstance_0(), DoubleSerializer_getInstance());
}
var IDClass;
function ID_1() {
  if (IDClass === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_1(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_1(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_5});
    IDClass = $;
  }
  return IDClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, EmployerRate$Companion$$childSerializers$_anonymous__42rifl);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, tmp_1, lazy(tmp_2, EmployerRate$Companion$$childSerializers$_anonymous__42rifl_0)];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_6();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_2() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.EmployerRate', this, 5);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('employer', false);
        tmp0_serialDesc.addElement_5pzumi_k$('activeRange', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('The days this rate applies to. Leave the end open and it runs until a later rate supersedes it.'));
        tmp0_serialDesc.addElement_5pzumi_k$('administration', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())("TCG's charge for administering one day, e.g. paidByEmployer * 0.15, where paidByEmployer is this employer's own share."));
        tmp0_serialDesc.addElement_5pzumi_k$('careProvider', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())("The employer's share of one day of care, e.g. owed * 0.6."));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['activeRange.start', 'careProvider']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['activeRange.start', 'employer', 'careProvider', 'administration']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['-activeRange.start']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_c3gg6c_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e(Companion_getInstance_0().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_5(), new (ID_1())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_2(), new (ID())(value.employer_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_4(), value.activeRange_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, tmp2_cached[3].get_value_j01efc_k$(), new (ExcelLikeFormula())(value.administration_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, tmp2_cached[4].get_value_j01efc_k$(), new (ExcelLikeFormula())(value.careProvider_1));
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_c3gg6c_k$(encoder, value instanceof EmployerRate() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp10_cached = Companion_getInstance_2().$childSerializers_1;
        if (tmp9_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_5();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_1())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_2();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp_5 = tmp10_cached[3].get_value_j01efc_k$();
          var tmp_6 = tmp7_local3;
          var tmp_7 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp_5, tmp_6 == null ? null : new (ExcelLikeFormula())(tmp_6));
          tmp7_local3 = tmp_7 == null ? null : tmp_7.string_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp_8 = tmp10_cached[4].get_value_j01efc_k$();
          var tmp_9 = tmp8_local4;
          var tmp_10 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp_8, tmp_9 == null ? null : new (ExcelLikeFormula())(tmp_9));
          tmp8_local4 = tmp_10 == null ? null : tmp_10.string_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_11 = $serializer_getInstance_5();
                var tmp_12 = tmp4_local0;
                var tmp_13 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_11, tmp_12 == null ? null : new (ID_1())(tmp_12));
                tmp4_local0 = tmp_13 == null ? null : tmp_13.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_14 = $serializer_getInstance_2();
                var tmp_15 = tmp5_local1;
                var tmp_16 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_14, tmp_15 == null ? null : new (ID())(tmp_15));
                tmp5_local1 = tmp_16 == null ? null : tmp_16.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_17 = tmp10_cached[3].get_value_j01efc_k$();
                var tmp_18 = tmp7_local3;
                var tmp_19 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp_17, tmp_18 == null ? null : new (ExcelLikeFormula())(tmp_18));
                tmp7_local3 = tmp_19 == null ? null : tmp_19.string_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_20 = tmp10_cached[4].get_value_j01efc_k$();
                var tmp_21 = tmp8_local4;
                var tmp_22 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp_20, tmp_21 == null ? null : new (ExcelLikeFormula())(tmp_21));
                tmp8_local4 = tmp_22 == null ? null : tmp_22.string_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp9_input.endStructure_1xqz0n_k$(tmp0_desc);
        return EmployerRate().new_org_thecommunitygroupinc_cares_EmployerRate_z2vnys_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_2().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_5(), $serializer_getInstance_2(), $serializer_getInstance_4(), tmp0_cached[3].get_value_j01efc_k$(), tmp0_cached[4].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_6() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var EmployerRateClass;
function EmployerRate() {
  if (EmployerRateClass === VOID) {
    class $ {
      constructor(_id, employer, activeRange, administration, careProvider) {
        Companion_getInstance_2();
        _id = _id === VOID ? _ID___init__impl__k1lb7e(Companion_getInstance_0().random_fimq0t_k$()) : _id;
        this._id_1 = _id;
        this.employer_1 = employer;
        this.activeRange_1 = activeRange;
        this.administration_1 = administration;
        this.careProvider_1 = careProvider;
      }
      get__id_bf4lzv_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_1())(this.get__id_bf4lzv_k$());
      }
      copy_9tlu7v_k$(_id, employer, activeRange, administration, careProvider) {
        return new (EmployerRate())(_id, employer, activeRange, administration, careProvider);
      }
      copy$default_5hu96p_k$(_id, employer, activeRange, administration, careProvider, $super) {
        _id = _id === VOID ? this._id_1 : _id;
        employer = employer === VOID ? this.employer_1 : employer;
        activeRange = activeRange === VOID ? this.activeRange_1 : activeRange;
        administration = administration === VOID ? this.administration_1 : administration;
        careProvider = careProvider === VOID ? this.careProvider_1 : careProvider;
        return $super === VOID ? this.copy_9tlu7v_k$(_id, employer, activeRange, administration, careProvider) : $super.copy_9tlu7v_k$.call(this, new (ID_1())(_id), new (ID())(employer), activeRange, new (ExcelLikeFormula())(administration), new (ExcelLikeFormula())(careProvider));
      }
      toString() {
        return 'EmployerRate(_id=' + ID__toString_impl_y5caka_1(this._id_1) + ', employer=' + ID__toString_impl_y5caka(this.employer_1) + ', activeRange=' + this.activeRange_1.toString() + ', administration=' + ExcelLikeFormula__toString_impl_rnbgi1(this.administration_1) + ', careProvider=' + ExcelLikeFormula__toString_impl_rnbgi1(this.careProvider_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_1(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz(this.employer_1) | 0;
        result = imul(result, 31) + this.activeRange_1.hashCode() | 0;
        result = imul(result, 31) + ExcelLikeFormula__hashCode_impl_5w5jp6(this.administration_1) | 0;
        result = imul(result, 31) + ExcelLikeFormula__hashCode_impl_5w5jp6(this.careProvider_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EmployerRate()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.employer_1, other.employer_1))
          return false;
        if (!this.activeRange_1.equals(other.activeRange_1))
          return false;
        if (!(this.administration_1 === other.administration_1))
          return false;
        if (!(this.careProvider_1 === other.careProvider_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_EmployerRate_z2vnys_k$(seen0, _id, employer, activeRange, administration, careProvider, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(30 === (30 & seen0))) {
          throwMissingFieldException(seen0, 30, $serializer_getInstance_6().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e(Companion_getInstance_0().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.employer_1 = employer;
        $this.activeRange_1 = activeRange;
        $this.administration_1 = administration;
        $this.careProvider_1 = careProvider;
        return $this;
      }
    }
    initMetadataForClass($, 'EmployerRate', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_6});
    EmployerRateClass = $;
  }
  return EmployerRateClass;
}
function _ID___init__impl__k1lb7e_0(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_0($this) {
  return $this;
}
function ID__toString_impl_y5caka_2($this) {
  return _ID___get_raw__impl__92g6u5_0($this).toString();
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_7();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_3() {
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.GrantRate.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(GrantRate())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_p2g6ls_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_0(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_p2g6ls_k$(encoder, value instanceof ID_2() ? value.raw_1 : THROW_CCE());
      }
      deserialize_1r5o5l_k$(decoder) {
        return _ID___init__impl__k1lb7e_0(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_2())(this.deserialize_1r5o5l_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_7() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
function ID__hashCode_impl_f4lulz_2($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_0($this, other) {
  if (!(other instanceof ID_2()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_0($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_2())(other instanceof ID_2() ? other.raw_1 : THROW_CCE()));
}
function GrantRate$Companion$$childSerializers$_anonymous__n7jgwe() {
  return Companion_getInstance().serializer_vc198b_k$($serializer_getInstance_1(), DoubleSerializer_getInstance());
}
function GrantRate$Companion$$childSerializers$_anonymous__n7jgwe_0() {
  return Companion_getInstance().serializer_vc198b_k$($serializer_getInstance(), DoubleSerializer_getInstance());
}
function GrantRate$Companion$$childSerializers$_anonymous__n7jgwe_1() {
  return Companion_getInstance().serializer_vc198b_k$($serializer_getInstance(), BooleanSerializer_getInstance());
}
var IDClass_0;
function ID_2() {
  if (IDClass_0 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_0(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_2(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_2(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_0(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_0(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_7});
    IDClass_0 = $;
  }
  return IDClass_0;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, GrantRate$Companion$$childSerializers$_anonymous__n7jgwe);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, GrantRate$Companion$$childSerializers$_anonymous__n7jgwe_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, tmp_1, tmp_3, lazy(tmp_4, GrantRate$Companion$$childSerializers$_anonymous__n7jgwe_1)];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_8();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_4() {
  if (Companion_instance_2 === VOID)
    new (Companion_2())();
  return Companion_instance_2;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.GrantRate', this, 6);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('grant', false);
        tmp0_serialDesc.addElement_5pzumi_k$('activeRange', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('The days this rate applies to. Leave the end open and it runs until a later rate supersedes it.'));
        tmp0_serialDesc.addElement_5pzumi_k$('administration', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())("An administration fee paid out of the grant itself, where paidByGrant is this grant's own share. Zero for the pilot grant."));
        tmp0_serialDesc.addElement_5pzumi_k$('careProvider', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())("The grant's match toward one day of care, e.g. owed * 0.3."));
        tmp0_serialDesc.addElement_5pzumi_k$('eligibility', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('Whether the grant funds a given day, e.g. ageMonths < 72.'));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['activeRange.start', 'careProvider']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['activeRange.start', 'grant', 'careProvider', 'eligibility', 'administration']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['-activeRange.start']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_ka19hn_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_4().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_0(Companion_getInstance_0().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_7(), new (ID_2())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_3(), new (ID_0())(value.grant_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_4(), value.activeRange_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.administration_1 === Companion_getInstance().ZERO_1)) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, tmp2_cached[3].get_value_j01efc_k$(), new (ExcelLikeFormula())(value.administration_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, tmp2_cached[4].get_value_j01efc_k$(), new (ExcelLikeFormula())(value.careProvider_1));
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.eligibility_1 === Companion_getInstance().TRUE_1)) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, tmp2_cached[5].get_value_j01efc_k$(), new (ExcelLikeFormula())(value.eligibility_1));
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ka19hn_k$(encoder, value instanceof GrantRate() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp11_cached = Companion_getInstance_4().$childSerializers_1;
        if (tmp10_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_7();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_2())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_3();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID_0())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp_5 = tmp11_cached[3].get_value_j01efc_k$();
          var tmp_6 = tmp7_local3;
          var tmp_7 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp_5, tmp_6 == null ? null : new (ExcelLikeFormula())(tmp_6));
          tmp7_local3 = tmp_7 == null ? null : tmp_7.string_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp_8 = tmp11_cached[4].get_value_j01efc_k$();
          var tmp_9 = tmp8_local4;
          var tmp_10 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp_8, tmp_9 == null ? null : new (ExcelLikeFormula())(tmp_9));
          tmp8_local4 = tmp_10 == null ? null : tmp_10.string_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp_11 = tmp11_cached[5].get_value_j01efc_k$();
          var tmp_12 = tmp9_local5;
          var tmp_13 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp_11, tmp_12 == null ? null : new (ExcelLikeFormula())(tmp_12));
          tmp9_local5 = tmp_13 == null ? null : tmp_13.string_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_14 = $serializer_getInstance_7();
                var tmp_15 = tmp4_local0;
                var tmp_16 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_14, tmp_15 == null ? null : new (ID_2())(tmp_15));
                tmp4_local0 = tmp_16 == null ? null : tmp_16.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_17 = $serializer_getInstance_3();
                var tmp_18 = tmp5_local1;
                var tmp_19 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_17, tmp_18 == null ? null : new (ID_0())(tmp_18));
                tmp5_local1 = tmp_19 == null ? null : tmp_19.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_20 = tmp11_cached[3].get_value_j01efc_k$();
                var tmp_21 = tmp7_local3;
                var tmp_22 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp_20, tmp_21 == null ? null : new (ExcelLikeFormula())(tmp_21));
                tmp7_local3 = tmp_22 == null ? null : tmp_22.string_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_23 = tmp11_cached[4].get_value_j01efc_k$();
                var tmp_24 = tmp8_local4;
                var tmp_25 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp_23, tmp_24 == null ? null : new (ExcelLikeFormula())(tmp_24));
                tmp8_local4 = tmp_25 == null ? null : tmp_25.string_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_26 = tmp11_cached[5].get_value_j01efc_k$();
                var tmp_27 = tmp9_local5;
                var tmp_28 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp_26, tmp_27 == null ? null : new (ExcelLikeFormula())(tmp_27));
                tmp9_local5 = tmp_28 == null ? null : tmp_28.string_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp10_input.endStructure_1xqz0n_k$(tmp0_desc);
        return GrantRate().new_org_thecommunitygroupinc_cares_GrantRate_o0uqad_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_4().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_7(), $serializer_getInstance_3(), $serializer_getInstance_4(), tmp0_cached[3].get_value_j01efc_k$(), tmp0_cached[4].get_value_j01efc_k$(), tmp0_cached[5].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_8() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var GrantRateClass;
function GrantRate() {
  if (GrantRateClass === VOID) {
    class $ {
      constructor(_id, grant, activeRange, administration, careProvider, eligibility) {
        Companion_getInstance_4();
        _id = _id === VOID ? _ID___init__impl__k1lb7e_0(Companion_getInstance_0().random_fimq0t_k$()) : _id;
        administration = administration === VOID ? Companion_getInstance().ZERO_1 : administration;
        eligibility = eligibility === VOID ? Companion_getInstance().TRUE_1 : eligibility;
        this._id_1 = _id;
        this.grant_1 = grant;
        this.activeRange_1 = activeRange;
        this.administration_1 = administration;
        this.careProvider_1 = careProvider;
        this.eligibility_1 = eligibility;
      }
      get__id_5w940m_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_2())(this.get__id_5w940m_k$());
      }
      copy_46111s_k$(_id, grant, activeRange, administration, careProvider, eligibility) {
        return new (GrantRate())(_id, grant, activeRange, administration, careProvider, eligibility);
      }
      copy$default_he6odu_k$(_id, grant, activeRange, administration, careProvider, eligibility, $super) {
        _id = _id === VOID ? this._id_1 : _id;
        grant = grant === VOID ? this.grant_1 : grant;
        activeRange = activeRange === VOID ? this.activeRange_1 : activeRange;
        administration = administration === VOID ? this.administration_1 : administration;
        careProvider = careProvider === VOID ? this.careProvider_1 : careProvider;
        eligibility = eligibility === VOID ? this.eligibility_1 : eligibility;
        return $super === VOID ? this.copy_46111s_k$(_id, grant, activeRange, administration, careProvider, eligibility) : $super.copy_46111s_k$.call(this, new (ID_2())(_id), new (ID_0())(grant), activeRange, new (ExcelLikeFormula())(administration), new (ExcelLikeFormula())(careProvider), new (ExcelLikeFormula())(eligibility));
      }
      toString() {
        return 'GrantRate(_id=' + ID__toString_impl_y5caka_2(this._id_1) + ', grant=' + ID__toString_impl_y5caka_0(this.grant_1) + ', activeRange=' + this.activeRange_1.toString() + ', administration=' + ExcelLikeFormula__toString_impl_rnbgi1(this.administration_1) + ', careProvider=' + ExcelLikeFormula__toString_impl_rnbgi1(this.careProvider_1) + ', eligibility=' + ExcelLikeFormula__toString_impl_rnbgi1(this.eligibility_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_2(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_0(this.grant_1) | 0;
        result = imul(result, 31) + this.activeRange_1.hashCode() | 0;
        result = imul(result, 31) + ExcelLikeFormula__hashCode_impl_5w5jp6(this.administration_1) | 0;
        result = imul(result, 31) + ExcelLikeFormula__hashCode_impl_5w5jp6(this.careProvider_1) | 0;
        result = imul(result, 31) + ExcelLikeFormula__hashCode_impl_5w5jp6(this.eligibility_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantRate()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.grant_1, other.grant_1))
          return false;
        if (!this.activeRange_1.equals(other.activeRange_1))
          return false;
        if (!(this.administration_1 === other.administration_1))
          return false;
        if (!(this.careProvider_1 === other.careProvider_1))
          return false;
        if (!(this.eligibility_1 === other.eligibility_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_GrantRate_o0uqad_k$(seen0, _id, grant, activeRange, administration, careProvider, eligibility, serializationConstructorMarker) {
        Companion_getInstance_4();
        if (!(22 === (22 & seen0))) {
          throwMissingFieldException(seen0, 22, $serializer_getInstance_8().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_0(Companion_getInstance_0().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.grant_1 = grant;
        $this.activeRange_1 = activeRange;
        if (0 === (seen0 & 8))
          $this.administration_1 = Companion_getInstance().ZERO_1;
        else
          $this.administration_1 = administration;
        $this.careProvider_1 = careProvider;
        if (0 === (seen0 & 32))
          $this.eligibility_1 = Companion_getInstance().TRUE_1;
        else
          $this.eligibility_1 = eligibility;
        return $this;
      }
    }
    initMetadataForClass($, 'GrantRate', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_8});
    GrantRateClass = $;
  }
  return GrantRateClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_1 = new (Companion_1())();
//endregion
//region block: exports
export {
  Companion_getInstance_2 as Companion_getInstance3a5neho85mvmw,
  Companion_instance as Companion_instance3tku9brqye44b,
  Companion_getInstance_4 as Companion_getInstance1z0h5xsn2wljo,
  Companion_instance_1 as Companion_instance2a6uspwvcbi9a,
  EmployerRate as EmployerRate2h2cumt5qtpn7,
  GrantRate as GrantRatevnytkougj5sm,
};
//endregion

//# sourceMappingURL=subsidyRates.mjs.map
